module.exports = __webpack_public_path__ + "static/assets/a31d29759b8a458f7eeee0b23f295fba.svg";